import { useEffect, useState } from 'react';
import { api } from './api';
import { FUEL_TYPES } from '../mock/mock';

const PALETTE = ['#7c1d2e', '#b91c1c', '#15803d', '#374151', '#1e40af', '#9333ea', '#0e7490', '#a16207', '#be185d', '#4d7c0f'];

export const toFuelList = (items) => (items || []).map((p, i) => {
  const known = FUEL_TYPES.find(f => f.id === p.id);
  return { id: p.id, name: p.name, color: known?.color || PALETTE[i % PALETTE.length] };
});

export function useFuels() {
  const [fuels, setFuels] = useState(FUEL_TYPES);
  useEffect(() => {
    api.get('/products/master')
      .then(r => { const list = toFuelList(r.data); if (list.length) setFuels(list); })
      .catch(() => {});
  }, []);
  return fuels;
}
